/**
 * Generated runtime TestId mirror for frontend/src/features/notifications/RecentNotifications.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RecentNotificationsTestIds = {
  cardTitleRecentNotifications: "card-title-recent-notifications",
  dashboardViewAllNotifications: "dashboard-view-all-notifications",
  recentNotificationsCard: "recent-notifications-card",
  dashboardNotification: (notification_id: string) => `dashboard-notification-${notification_id}`,
  dashboardNotificationPrefix: () => "dashboard-notification-" as TestIdPrefix
} as const;
